import { render, staticRenderFns } from "./AssistenciaFuneral.vue?vue&type=template&id=d0c42f7a&scoped=true&"
import script from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
export * from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
import style0 from "./AssistenciaFuneral.vue?vue&type=style&index=0&id=d0c42f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c42f7a",
  null
  
)

export default component.exports